import React from "react"
import locationIcon from "../images/location.png"
import Intent from "./link"

function ExpCard(props) {
  console.log('props',props);

  const { cardTitle, cardSubtitle, cardImage, cardDuration,  cardLocation, readMore} = props
  return (
    <div className="col-lg-3 exp-card">
      <div className="card mx-4">
        <img src={cardImage} className="card-img-top"></img>
        <div className="card-body">
          <h3 className="card-title">{cardTitle}</h3>
          <h6 style={{color: "#ccc"}} className="card-text">{cardSubtitle}</h6>
          <p className="card-text">
          <span>
            <img src="https://images.emojiterra.com/twitter/512px/1f5d3.png" style={{width: "17px", height: "17px", margin: "0px 10px 0px 0px"}}></img>
          </span>
          {cardDuration}<br />
          <span>
            <img src={locationIcon} style={{width: "20px", height: "20px", margin: "10px 5px 10px 0px"}}></img>
          </span>
          {cardLocation}
          </p>
        </div>
        <div className="card-footer text-center">
          {/* <a className="read-more" href={readMore} target="_blank" rel="noopener noreferrer">Read More</a> */}
          <Intent to={readMore}><div className="read-more">Read More</div></Intent>
        </div>
      </div>
    </div>
  )
}

export default ExpCard
